<template>
  <b-card>
    <b-card-title class="mb-1 d-flex align-items-center">
      <span style="margin-left: 5px">{{ title }}</span>
    </b-card-title>
    <loader v-if="loading" />
    <div v-else class="row">
      <div class="col-md-4 py-2">
        <div class="media">
          <div class="media-aside mr-2 align-self-start">
            <span class="b-avatar badge-light-success rounded-circle" style="width: 48px; height: 48px">
              <span class="b-avatar-custom"><i class="bi bi-check-circle fs-18"></i></span>
            </span>
          </div>
          <div class="media-body my-auto">
            <h4 class="font-weight-bolder mb-0">{{ data.fanpage_synced || 0 }}</h4>
            <p class="card-text font-small-3 mb-0">Postingan Synced</p>
          </div>
        </div>
      </div>
      <div class="col-md-4 py-2">
        <div class="media">
          <div class="media-aside mr-2 align-self-start">
            <span class="b-avatar badge-light-primary rounded-circle" style="width: 48px; height: 48px">
              <span class="b-avatar-custom"><i class="bi bi-person-check fs-18"></i></span>
            </span>
          </div>
          <div class="media-body my-auto">
            <h4 class="font-weight-bolder mb-0">{{ data.active_users || 0 }}</h4>
            <p class="card-text font-small-3 mb-0">Operator Aktif</p>
          </div>
        </div>
      </div>
      <div class="col-md-4 py-2">
        <div class="media">
          <div class="media-aside mr-2 align-self-start">
            <span class="b-avatar badge-light-info rounded-circle" style="width: 48px; height: 48px">
              <span class="b-avatar-custom"><i class="bi bi-percent fs-18"></i></span>
            </span>
          </div>
          <div class="media-body my-auto">
            <h4 class="font-weight-bolder mb-0">{{ parseFloat(data.success_rate || 0).toFixed(2) }}%</h4>
            <p class="card-text font-small-3 mb-0">Success Rate</p>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>
<script>
import loader from "@/views/components/loader.vue";

export default {
  name: "SmdKpiCard",
  components: { loader },
  props: {
    title: { type: String, default: "KPI Statistik" },
    loading: { type: Boolean, default: false },
    data: { type: Object, default: () => ({}) },
  },
};
</script>
